import { Divider, Flex } from "@mantine/core";
import { Container, LastUpdate } from "./StyledComponents";
import CustomSelect from "../common/Inputs/CustomSelect";
import styled from "styled-components";
import { theme } from "../../theme";
import { useFilterContext } from "../../context/DashboardFilterContext";
import { useAuth } from "../../context/AuthContext";
import { getLiveTopMenu } from "../../api/dashboardApi";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const Filters = ({ flex }: { flex: any }) => {
  const { handleChange, filters }: any = useFilterContext();
  const { roleSelectData, departmentSelectData } = useAuth();
  const [data, setData] = useState<any>();

  const getTopMenuData = async () => {
    try {
      const { data, success } = await getLiveTopMenu();
      if (success) {
        setData(data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getTopMenuData();
  }, []);

  return (
    <Container $flex={flex}>
      <Flex justify={"space-between"}>
        <Flex gap={12}>
          <CustomSelect
            onChange={(value: any) => handleChange("department", value)}
            placeholder="Departman"
            searchable={false}
            data={departmentSelectData}
          />
          <CustomSelect
            onChange={(value: any) => handleChange("role", value)}
            placeholder="Rol"
            searchable={false}
            data={roleSelectData}
            clearable
            value={filters?.role}
          />
        </Flex>
        <Flex gap={20}>
          <CountBox $color={theme.colors.brand.normal}>
            <span>{data?.total}</span>
            <div>Toplam</div>
          </CountBox>
          <CountBox $color={theme.colors.alert.green}>
            <span>{data?.active}</span>
            <div>Mevcut</div>
          </CountBox>
          <CountBox $color={theme.colors.alert.red}>
            <span>{data?.late}</span>
            <div>Geciken</div>
          </CountBox>
          {/* <CountBox $color={theme.colors.alert.blue}>
            <span>4</span>
            <div>İzinli</div>
          </CountBox> */}
          <Divider orientation="vertical" />
          <LastUpdate>
            <Flex direction={"column"} align={"end"}>
              <div>Son Güncelleme:</div>
              <span>{dayjs(data?.time).format("HH:mm:ss")}</span>
            </Flex>
          </LastUpdate>
        </Flex>
      </Flex>
    </Container>
  );
};

export default Filters;

const CountBox = styled.div<{ $color: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: ${({ $color }) => $color};
  }
`;
